var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sub-values" }, [
    _c("div", { staticClass: "sub-value" }, [
      _c("div", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm.data.min) + " - " + _vm._s(_vm.data.max) + " Monate")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }